export const SHARED_LAYOUT_TRANSITION = {
  type: 'spring',
  stiffness: 500,
  damping: 40,
  mass: 1,
  precision: 0.01,
};

export const BASE_LAYOUT_VARIANTS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};
